/* Essential Fragrances bilingual bundles & free shipping progress */
(function(){
  'use strict';
  const fr = (document.documentElement.lang || 'en').toLowerCase().startsWith('fr');
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (fr ? '/fr/' : '/');
  const base = shopRoot.endsWith('/') ? shopRoot : shopRoot + '/';
  const money = value => (Math.max(0,value)/100).toFixed(2);
  function currentVariant(){
    const select = document.getElementById('EFPVariant');
    return select && select.selectedOptions ? select.selectedOptions[0] : null;
  }
  function sync(){
    const title = currentVariant()?.textContent?.trim() || '';
    document.querySelectorAll('[data-ef-bundle-current-name]').forEach(el=>{el.textContent=title;});
  }
  sync();
  document.getElementById('EFPVariant')?.addEventListener('change',sync);
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-ef-bundle-add]');
    if(!button||button.disabled)return;
    event.preventDefault();
    const card=button.closest('[data-ef-bundle-key]');
    if(!card)return;
    const feedback=card.querySelector('.efb-card__feedback');
    const showFeedback=msg=>{if(feedback){feedback.hidden=false;feedback.textContent=msg;}};
    const selects=[...card.querySelectorAll('select[data-ef-bundle-variant]')];
    const ids=selects.map(s=>Number(s.value));
    const allSelectedAvailable=selects.every(s=>s.value && !s.selectedOptions[0]?.disabled);
    if(card.querySelector('[data-ef-bundle-current]')){
      const variant=currentVariant();
      if(!variant?.value||variant.dataset.available!=='true'){
        showFeedback(fr?'Choisissez une fragrance en stock.':'Choose an in-stock scent.');return;
      }
      ids.push(Number(variant.value));
    }
    if(!allSelectedAvailable||!ids.length||ids.some(n=>!Number.isSafeInteger(n)||n<=0)){
      showFeedback(fr?'Choisissez des fragrances en stock.':'Choose in-stock scents.');return;
    }
    const quantities=new Map();
    ids.forEach(id=>quantities.set(id,(quantities.get(id)||0)+1));
    button.disabled=true;
    showFeedback(fr?'Ajout au panier…':'Adding your bundle…');
    try{
      const response=await fetch(base+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[...quantities].map(([id,quantity])=>({id,quantity}))})
      });
      if(!response.ok){
        const error=await response.json().catch(()=>({}));
        throw new Error(error.description||error.message||(fr?'Erreur de panier':'Cart error'));
      }
      window.location.assign(base+'cart');
    }catch(error){
      showFeedback((fr?'Impossible d’ajouter l’ensemble : ':'Could not add bundle: ')+error.message);
      button.disabled=false;
    }
  });
  const shippingNodes=[...document.querySelectorAll('[data-ef-shipping]')];
  if(!shippingNodes.length)return;
  let loading=false;
  async function refresh(){
    if(loading)return;loading=true;
    try{
      const response=await fetch(base+'cart.js',{cache:'no-store'});
      if(!response.ok)return;
      const cart=await response.json();
      const total=Math.max(0,Number(cart.total_price)||0);
      const remain=Math.max(0,5000-total);
      shippingNodes.forEach(node=>{
        const fill=node.querySelector('[data-ef-shipping-fill]');
        const label=node.querySelector('[data-ef-shipping-text]');
        if(fill)fill.style.width=Math.min(100,Math.round(total/5000*100))+'%';
        if(label)label.textContent=remain===0
          ? (fr?'Livraison standard gratuite au Canada débloquée!':'Free Canadian standard shipping unlocked!')
          : (fr?'Ajoutez '+money(remain)+' $ CA pour la livraison standard gratuite au Canada.':'Add $'+money(remain)+' CAD for free Canadian standard shipping.');
      });
    }catch(error){console.warn('Shipping progress unavailable',error);}
    finally{loading=false;}
  }
  refresh();
  const totalEl=document.getElementById('CartTotal');
  if(totalEl&&typeof MutationObserver!=='undefined'){
    new MutationObserver(()=>{void refresh();}).observe(totalEl,{subtree:true,childList:true,characterData:true});
  }
  document.getElementById('CartDrawer')?.addEventListener('click',()=>{void refresh();});
  document.addEventListener('ef:cart:item-added',()=>{void refresh();});
})();
